import { Decorator, FormApi } from 'final-form'
import { getIn } from 'final-form'
import createDecorator, { FindInput } from 'final-form-focus'
import { get } from 'lodash'

const createFindInput = (form: FormApi): FindInput => {
  const findInput = (
    inputs: HTMLInputElement[],
  ): HTMLInputElement | undefined => {
    const errors = get(form.getState(), 'errors') // get up to date errors
    const result = inputs.find((input) => {
      const name = input.name || input.dataset.name
      return name ? getIn(errors as any, name) : undefined
    })
    if (result) {
      result.scrollIntoView({ behavior: 'smooth', block: 'center' })
      // result.focus()
    }
    // return undefined
    return result
  }
  return findInput
}

const getFormInputs = (name: string) => (): HTMLInputElement[] => {
  if (typeof document === 'undefined' || !name || name === '') {
    return []
  }
  const form = document.forms[name]
  const inputs = form && form.length ? Array.prototype.slice.call(form) : [] // cast cheat to get from HTMLFormElement children to FocusableInput

  const selectFields = Array.prototype.slice.call(
    document.querySelectorAll('[data-select]'),
  )

  const allInputs = inputs.concat(selectFields)
  return allInputs
}

// create decorator with reference to the form object
const createFocusOnError = (name: string, form: FormApi): Decorator => {
  return createDecorator(getFormInputs(name), createFindInput(form))
}

export default createFocusOnError
